
import { defineComponent, reactive, toRaw, toRefs, watch } from "vue";
import dayjs, { Dayjs } from "dayjs";
import { Form, Modal } from "ant-design-vue";
import { useStore } from "vuex";
import lGallery from "./gallery.vue";
import lFile from "./file.vue";
import lEditor from "./editor.vue";
const useForm = Form.useForm;
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: Record<any, any>;
  percent?: number;
  url?: string;
  preview?: string;
  originFileObj?: any;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

export default defineComponent({
  components: {
    lGallery,
    lFile,
    lEditor,
  },
  props: {
    items: {
      type: Array,
      default: [],
    },
    btns: {
      type: Array,
      default: [],
    },
  },
  emits: ["preview", "upload", "submit"],
  setup(props, { emit }) {
    const store = useStore();
    const form = reactive({
      show: false,
      labelCol: 4,
      refs: {} as any,
      fRef: (e: any) => {
        if (e) {
          const name = e.name;
          if (form.refs[name]) {
            form.refs[name].ref = e;
          }
        }
      },
      models: {} as Record<any, any>,
      rules: {} as Record<any, any>,
      validate: {} as any,
      validateInfos: {} as Record<any, any>,
      init: (items: Record<any, any>) => {
        items.forEach((item: Record<any, any>) => {
          // value
          if (item.type === "interval") {
            if (item.value && item.value.length === 2) {
              const intervalItem: [Dayjs, Dayjs] = [
                dayjs(item.value[0], interval.dateFormat),
                dayjs(item.value[1], interval.dateFormat),
              ];
              item.value = intervalItem;
            }
          } else if (item.type === "gallery") {
            const galleryItems: Record<any, any> = [];
            item.value.forEach((vItem: Record<any, any>) => {
              galleryItems.push({
                uid: vItem.key,
                name: vItem.name,
                url: vItem.url,
                status: "done",
              });
            });
            item.value = galleryItems;
          } else if (item.type === "file") {
            const fileItems: Record<any, any> = [];
            item.value.forEach((vItem: Record<any, any>) => {
              fileItems.push({
                uid: vItem.key,
                name: vItem.name,
                url: vItem.url,
                status: "done",
              });
            });
            item.value = fileItems;
          }
          form.models[item.name] = item.value;
          // rule
          if (item.rules !== undefined) {
            form.rules[item.name] = item.rules;
          }
          // ref
          if (item.type === "gallery") {
            form.refs[item.name] = { ref: null };
          } else if (item.type === "file") {
            form.refs[item.name] = { ref: null };
          } else if (item.type === "editor") {
            form.refs[item.name] = { ref: null };
          }
        });
        const modelRef = reactive(form.models);
        const rulesRef = reactive(form.rules);
        const { validate, validateInfos } = useForm(modelRef, rulesRef);
        form.validate = validate;
        form.validateInfos = validateInfos;
        form.show = true;
      },
      submit: () => {
        form
          .validate()
          .then(() => {
            Modal.confirm({
              centered: true,
              title: "保存确认",
              okText: "确认",
              cancelText: "取消",
              async onOk() {
                const submitData: Record<any, any> = Object.assign(
                  {},
                  toRaw(form.models)
                );
                props.items.forEach((item: any) => {
                  const itemName = item.name;
                  // 判断包含时间段
                  if (item.type === "interval") {
                    if (submitData[itemName].length === 2) {
                      const start = submitData[itemName][0].format(
                        interval.dateFormat
                      );
                      const end = submitData[itemName][1].format(
                        interval.dateFormat
                      );
                      submitData[itemName] = [start, end];
                    }
                  }
                  // 判断包含地区
                  if (item.type === "area") {
                    const areaValues: Record<any, any> = form.models[itemName];
                    const areaText: Record<any, any> = [];
                    let areaSingle: Record<any, any> = areas.areaOptions;
                    let areaItem: Record<any, any> = {};
                    areaValues.forEach((mItem: Record<any, any>) => {
                      areaItem = areaSingle.find(
                        (aItem: Record<any, any>) => aItem.code === mItem
                      );
                      if (areaItem) {
                        areaText.push(areaItem.label);
                        if (areaItem.children) {
                          areaSingle = areaItem.children;
                        }
                      }
                    });
                    submitData[itemName + "Text"] = areaText;
                  }
                  // 判断包含图片集
                  if (item.type === "gallery") {
                    submitData[itemName] = form.refs[itemName].ref.getValues();
                  }
                  // 判断包含文件
                  if (item.type === "file") {
                    submitData[itemName] = form.refs[itemName].ref.getValues();
                  }
                  // 判断包含编辑器
                  if (item.type === "editor") {
                    submitData[itemName] = form.refs[itemName].ref.eContent;
                  }
                });
                emit("submit", submitData);
              },
            });
          })
          .catch((err: any) => {
            console.log("form error", err);
          });
      },
    });
    const interval = reactive({
      dateFormat: "YYYY-MM-DD HH:mm",
      timeFormat: "HH:mm",
    });
    const areas = reactive({
      areaOptions: store.getters.lbAdminAreas as Record<any, any>,
      searchAreaFilter: (inputValue: string, path: Record<any, any>) => {
        return path.some(
          (option: { label: string }) =>
            option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
        );
      },
    });
    watch(
      () => store.getters.lbAdminAreas,
      (s) => {
        areas.areaOptions = s;
      }
    );
    const editor = reactive({
      eInit: {
        language: "zh_CN",
        toolbar: "",
        branding: false,
        resize: false,
        menubar: "format",
      },
    });
    const build = () => {
      form.init(props.items);
    };
    return {
      ...toRefs(form),
      ...toRefs(interval),
      ...toRefs(areas),
      ...toRefs(editor),
      build,
    };
  },
});
